export { default as MenuFavoriteItem } from './MenuFavoriteItem';
